import { render, staticRenderFns } from "./normatividadContable.vue?vue&type=template&id=161baca3&scoped=true"
import script from "./normatividadContable.vue?vue&type=script&lang=js"
export * from "./normatividadContable.vue?vue&type=script&lang=js"
import style0 from "./normatividadContable.vue?vue&type=style&index=0&id=161baca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161baca3",
  null
  
)

export default component.exports